import React from "react";

import BackgroundImg from "../assets/images/servicesImg.png";
import GetInTouch from "../components/getInTouchComponent/getInTouchComponent";
import "./styles.scss";
import TestimonialsTravala from "../components/testimonialsTravala/testimonialTravala";
import ServiceIcon from "../components/services/serviceIcons";
import { ReactComponent as CodeIcon } from "../assets/icons/codeIcon.svg";
import { ReactComponent as ConsultingIcon } from "../assets/icons/consultingIcon.svg";
import { ReactComponent as CorporateMngIcon } from "../assets/icons/corporateMngIcon.svg";
import { ReactComponent as TechDevIcon } from "../assets/icons/techDevIcon.svg";
import { Button } from "react-bootstrap";
import './homePage.scss';
import Newslatter from "../components/newslatter/newsletter";
import { useNavigate } from "react-router-dom";


const homePageBgImage = require('../assets/images/homepage-bg.png');
const oldManBgImage = require('../assets/images/old-man.png');


const HomePage = () => {
  const navigate = useNavigate();

  return (<div className="main-layout-container">
    <div className="header-container" style={{ backgroundImage: `url(${homePageBgImage})` }}>
      <div className="overlay">
        <div className="content">
          <span className="title">Custom Software Development</span>
          <p className="description"><span className="yellow">Cube Global</span> offers the development of powerful, one-of-a-kind software intended to meet customers’ unique demands.</p>
            <Button
              type="submit"
              className="btn-submit homepage-btn"
              onClick={() => { navigate('/services') }}
            >
              Discover More
            </Button>

        </div>
      </div>
    </div>
    <div className="services-section">
      <span className="title">Our Services</span>
      <span className="description">We deliver expert custom software development, technology and corporate management, as well as consulting services, specifically designed for small and medium-sized businesses.</span>
    </div>
    <div className="services-content-list">
      <ServiceIcon
        title={"Software Development"}
        content={
          "We provide expert custom software development, technology solutions, corporate management, and consulting services for small and medium-sized businesses, driving innovation and optimizing processes"
        }
        icon={CodeIcon}
        path={'/software-development'}
      />

      <ServiceIcon
        title={"Technology Development"}
        content={
          "Our team leverages the latest technologies to develop scalable, future-proof solutions that support business growth. By focusing on innovation and adaptability, we ensure that your systems are equipped to handle evolving market demands and drive long-term success"
        }
        icon={TechDevIcon}
        path={'/tehnology-management'}
      />

      <ServiceIcon
        title={"Corporate Management"}
        content={
          "We provide strategic corporate management services designed to streamline operations, enhance organizational efficiency, and drive sustained growth, ultimately increasing the overall value of your company."
        }
        icon={CorporateMngIcon}
        path={'/corporate-management'}
      />

      <ServiceIcon
        title={"Consulting"}
        content={
          "Our expert consulting services guide businesses through critical decisions, helping them remain competitive in a dynamic marketplace, while offering tailored guidance and solutions across multiple platforms"
        }
        icon={ConsultingIcon}
        path={'/consulting'}
      />
    </div>
    <div className="about-us-section">
      <div className="text-container">
        <span className="title">About Us</span>
        <span className="description">Cube Global is a Saint Kitts and Nevis-based provider of custom software development and IT consulting services, supported by a team of international IT professionals. We specialize in delivering tailored and platform-based solutions to midsized and large companies across various industries. Additionally, we guide small startups on their journey to success. At Cube Global, we are committed to delivering innovative software solutions for middle-market and enterprise clients in multiple sectors including:</span>
        <div className="list-container">
          <div className="list">
            <span className="item">Banking</span>
            <span className="item">Finance</span>
            <span className="item">Healthcare</span>
          </div>
          <div className="list">
            <span className="item">Retail</span>
            <span className="item">Telecom</span>
            <span className="item">Public Sector</span>
          </div>
        </div>
        <Button
          type="submit"
          className="btn-submit homepage-btn"
          onClick={() => { navigate('/about-us') }}
        >
          Read More
        </Button>
      </div>
      <img src={oldManBgImage} alt="People working" />
    </div>
    <div className="statistic-section">
      <div className="item">
        <span className="value">30</span>
        <span className="label">IT Professionals</span>
      </div>
      <div className="item">
        <span className="value">120</span>
        <span className="label">Satisfied Clients</span>
      </div>
      <div className="item">
        <span className="value">15</span>
        <span className="label">Countries</span>
      </div>
    </div>
    {/* <TestimonialsTravala /> */}
    <GetInTouch />
    {/* <Newslatter/> */}
  </div>)
}

export default HomePage;